import { Modal } from 'antd';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmClearModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      title={"Confirm Deletion"}
      open={isOpen}
      onOk={onConfirm}
      onCancel={onClose}
      okText={"Yes, Delete All"}
      cancelText={"Cancel"}
      okType='danger'
    >
      <p>Are you sure you want to delete all rows? This action cannot be undone.</p>
    </Modal>
  );
};

export default ConfirmClearModal;